/**
 * Convert UTC ISO string to local datetime format for datetime-local inputs
 */
export function utcToLocalDatetimeString(
  utcDateString: string | undefined,
): string {
  if (!utcDateString) return "";

  const date = new Date(utcDateString);

  // Format to YYYY-MM-DDThh:mm (format required by datetime-local input)
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/**
 * Convert local datetime string back to UTC ISO
 */
export function localToUtcIsoString(localDatetimeString: string): string {
  if (!localDatetimeString) {
    // Return current time in UTC if no date provided
    return new Date().toISOString();
  }

  try {
    const date = new Date(localDatetimeString);
    return date.toISOString();
  } catch (error) {
    console.error("Invalid date format:", localDatetimeString);
    return new Date().toISOString();
  }
}
